<div class="c">

    <!-- <div class="header">
    <p class="titr">{{publicservice.Texts.Texts['waste-list8']}}</p>
    </div> -->

    <div class="headerback">
        <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
           <mat-icon>arrow_back</mat-icon>
         </button> -->
        <p class="title">{{publicservice.Texts.Texts["services1"]}}</p>

        <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backmap()"
            class="backbtn">
            <mat-icon>arrow_forward</mat-icon>
        </button>

    </div>

    <div class="tableicon">

        <div class="r1">
            <div class="wasteitem">
                <img class="wasteicon" src="assets/images/household.png" style="opacity: 0.5;">
                <p class="iconText" style="opacity: 0.5;">نظافت منزل</p>
                <p class="iconText2">...به زودی راه اندازی می شود</p>
            </div>
            <div class="wasteitem">
                <img class="wasteicon" src="assets/images/truck.png" style="opacity: 0.5;">
                <p class="iconText" style="opacity: 0.5;">وانت بار کرایه</p>
                <p class="iconText2">...به زودی راه اندازی می شود</p>
            </div>
        </div>
        <div class="r2">
            <div class="wasteitem" (click)="wasteClick()">
                <img class="wasteicon" src="assets/images/drywaste.png"  [class]="key1">
                <mat-spinner id="loading" *ngIf="loading"></mat-spinner>
                <p class="iconText"  [class]="key1">انتقال پسماند خشک</p>
                <p class="iconText2" style="visibility: hidden;">...به زودی راه اندازی می شود</p>
            </div>
            <div class="wasteitem">
                <img class="wasteicon" src="assets/images/toolbox.png" style="opacity: 0.5;">
                <p class="iconText" style="opacity: 0.5;">خدمات کارگری</p>
                <p class="iconText2">...به زودی راه اندازی می شود</p>
            </div>
        </div>

    </div>

</div>